import type { RouteLocationNormalized } from 'vue-router'
import type { RouteGuard, GuardResult } from './RouteGuard'
import { useAuthStore } from '@/stores/auth'
import { authReady } from '@/services/firebase/config'

export class RequiresAuthGuard implements RouteGuard {
  name = 'requiresAuth'

  async canActivate(to: RouteLocationNormalized): Promise<GuardResult> {
    // Wait for Firebase Auth to restore session from IndexedDB before deciding
    await authReady

    const authStore = useAuthStore()

    const requiresAuth = to.meta.requiresAuth !== false

    if (requiresAuth && !authStore.isAuthenticated) {
      return '/login'
    }

    if (!requiresAuth && authStore.isAuthenticated) {
      return '/dashboard'
    }

    return true
  }
}
